import { Link } from "react-router-dom";
import { LegalLayout, LegalSection } from "@/components/LegalLayout";
import { LEGAL, ph } from "@/config/legal";
import { openConsentBanner } from "@/lib/consent";

export default function CookiePage() {
  return (
    <LegalLayout title="Cookie Policy" testId="cookie-page">
      <p className="text-sm sm:text-base text-ink/80 leading-relaxed">
        La presente Cookie Policy descrive i cookie e le tecnologie simili utilizzate dal sito Progetto HOSPITALITY{LEGAL.siteUrl ? <> (<a href={LEGAL.siteUrl} className="underline text-forest" data-testid="cookie-site-url">{LEGAL.siteUrl.replace(/^https?:\/\//, "")}</a>)</> : null}, gestito da{" "}
        <span data-testid="cookie-owner-name">{ph(LEGAL.ragioneSociale, "Ragione sociale")}{LEGAL.partitaIva ? ` – P.IVA ${LEGAL.partitaIva}` : ""}</span>, e le modalità per gestire il consenso.
      </p>

      <LegalSection title="1. Cosa sono i cookie">
        <p>I cookie sono piccoli file di testo che il sito salva sul dispositivo dell'utente per memorizzare informazioni e preferenze. Possono essere di prima parte (impostati da questo sito) o di terze parti (impostati da servizi esterni).</p>
      </LegalSection>

      <LegalSection title="2. Cookie tecnici (necessari)">
        <p>Sono indispensabili per il funzionamento del sito e non richiedono consenso. In particolare, il sito memorizza nel browser la preferenza espressa sui cookie (chiave <code className="text-xs bg-ivory px-1">ph_cookie_consent</code>) per non riproporre il banner a ogni visita.</p>
      </LegalSection>

      <LegalSection title="3. Cookie di analisi e marketing (previo consenso)">
        <p>Solo se l'utente seleziona "Accetta tutti", il sito può attivare i seguenti servizi di terze parti:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li><strong>Google Analytics (GA4)</strong> – Google Ireland Ltd.: misurazione anonima delle visite e dell'uso delle pagine.</li>
          <li><strong>Meta Pixel</strong> – Meta Platforms Ireland Ltd.: misurazione dell'efficacia delle campagne pubblicitarie e delle richieste inviate.</li>
        </ul>
        <p>Senza consenso questi servizi non vengono caricati e nessun dato è trasmesso a tali fornitori. Per le rispettive informative si rimanda ai siti dei fornitori.</p>
      </LegalSection>

      <LegalSection title="4. Come modificare il consenso">
        <p>Puoi modificare o revocare la tua scelta in qualsiasi momento tramite il link "Preferenze cookie" presente nel footer, oppure cliccando qui:</p>
        <button onClick={openConsentBanner} className="btn-outline !py-2.5 !px-5" data-testid="cookie-page-preferences-button">Apri le preferenze cookie</button>
        <p>È inoltre possibile eliminare i cookie dalle impostazioni del browser.</p>
      </LegalSection>

      <LegalSection title="5. Titolare e contatti">
        <p data-testid="cookie-owner-line">
          {[ph(LEGAL.ragioneSociale, "Ragione sociale"), LEGAL.partitaIva ? `P.IVA ${LEGAL.partitaIva}` : "[Partita IVA da inserire]", ph(LEGAL.sede, "Sede"), ph(LEGAL.email, "Email")].join(" – ")}
        </p>
        <p>Per ogni informazione sul trattamento dei dati consulta la <Link to="/privacy" className="underline text-forest" data-testid="cookie-to-privacy-link">Privacy Policy</Link> oppure scrivi a {LEGAL.email ? <a href={`mailto:${LEGAL.email}`} className="underline text-forest">{LEGAL.email}</a> : ph("", "Email")}.</p>
      </LegalSection>
    </LegalLayout>
  );
}
